import { render, staticRenderFns } from "./InventoryWorkflowForm.vue?vue&type=template&id=9e8a7edc&scoped=true&lang=html&"
import script from "./InventoryWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./InventoryWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8a7edc",
  null
  
)

export default component.exports